import type { SourceCardDto } from '../api/client.js';

/**
 * Whether a recitation plays is no longer decided here.
 *
 * The rule — Qur'an only, human audio from the approved provider, https only, never a hadith — is a
 * religious-content decision, and `delivery` states it on the card as `canPlayRecitation`. This
 * function used to re-derive it from four sentences of policy, which meant a second client would
 * have had to derive it again, with nothing failing if it got one of them wrong.
 *
 * What remains is the mapping from that answer to a url the audio element can use. A card that may
 * not play yields no player at all, and falls back to text — always a complete rendering of it.
 */
export function playableRecitation(card: SourceCardDto): string | null {
  return card.canPlayRecitation ? card.humanRecitationUrl : null;
}
